import {Component, OnInit, Compiler} from '@angular/core';
//import {Control} from '@angular/common';
import {UserService, SeedDataService } from '../../Services/index';

import {DataTable, SelectItem, DropdownModule, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, GrowlModule, Message, ConfirmationService, MultiSelectModule, BlockUIModule, SharedModule} from 'primeng/primeng';


import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { LOVTypes, LOV, LOVTypeVal, LOVVal, LOVAccessType } from '../../Models/seed.data';

//import {ROUTER_DIRECTIVES, RouteConfig} from '@angular/router';

import { Observable }     from 'rxjs/Observable';

@Component({
    //moduleId: module.id,
    templateUrl: './seed.data.html'
})

export class SeedDataComponent implements OnInit {

    msgs: Message[] = [];

	menuLOVTypes: SelectItem[];
    selectedLOV: string;

    listLOV: PrimeLOV[];
    addNewLOVDialog: boolean = false;
    txtTypeVal: string;
    txtTypeID: string;
    headerLabel: string;
    lblType: string;

    lovVal: LOVVal;

    hdnLOVID: string;

    lovForm: PrimeLOV = new PrimeLOV();
    userform: PrimeLOV;
    submitted: boolean;
    txtTypeName: string;
    synced: boolean;
    isNameTake: boolean;

    nameMaxLength: number = 200;
    blockedDocument: boolean = false;
    ValidationErrs: any = {}
    PageHeading: string = "";
    currentUserId: any;

    valAddInfo1: any = '';
    valAddInfo2: any = '';
    valAddInfo3: any = '';

    txtKeywordSearch: string = "";

    /* ------------------- New -------------------*/
    isNewLov: boolean = true;
    lovObj: PrimeLOV;


    LOVActions: any = {}

    isLOVEditable: boolean = true;
    isAddNewLOV: boolean = true;
    isDeleteLOV: boolean = true;

    isLabel1: boolean = false;
    label1: string;
    label1InputType: string;
    isLabel1Required: boolean = false;
    ddlLabel1: SelectItem[];
    label1DropDownFieldForSave: string;
    label1CustomValidationFunction: string;
    label1MultiSelectCount: number;

    isLabel2: boolean = false;
    label2: string;
    label2InputType: string;
    isLabel2Required: boolean = false;
    ddlLabel2: SelectItem[];
    label2DropDownFieldForSave: string;
    label2CustomValidationFunction: string;
    label2MultiSelectCount: number;

    isLabel3: boolean = false;
    label3: string;
    label3InputType: string;
    isLabel3Required: boolean = false;
    ddlLabel3: SelectItem[];
    label3DropDownFieldForSave: string;
    label3CustomValidationFunction: string;
    label3MultiSelectCount: number;
    /* ------------------- END -------------------*/

    constructor(private seedDataService: SeedDataService, private fb: FormBuilder, private confirmationService: ConfirmationService, private _compiler: Compiler) {
        this.menuLOVTypes = [];
        this.listLOV = [];
        this.ddlLabel1 = [];
    }

    ngOnInit() {

        this._compiler.clearCache();
        this.hideValidationMsg();

        this.userform = this.fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength), this.validateName.bind(this)])],
            'additionalInfo1': ["", this.validateNameAdditionalInfo1.bind(this)],
            'additionalInfo2': ["", this.validateNameAdditionalInfo2.bind(this)],
            'additionalInfo3': ["", this.validateNameAdditionalInfo3.bind(this)]
        });

        this.seedDataService.getLOVType().subscribe((lstLOVTypes: SelectItem[]) => {
          
            this.menuLOVTypes = lstLOVTypes;
            this.selectedLOV = lstLOVTypes[0].value;
            this.bindList(this.selectedLOV,null);
        });
    }

	validateNameAdditionalInfo1(control: FormControl) {
        if (this.isLabel1Required && this.label1InputType != 'multiselect') {
            if (!control.value) {
                return { "isInvalidAdditionalInfo1": true };
            }
        } else if (this.isLabel1Required && this.label1InputType == 'multiselect') {
            if (control.value != null && control.value != undefined && control.value != '') {
                return null;
            } else {
                return { "isInvalidAdditionalInfo1": true };
            }
        }
        return null;
    }

	validateNameAdditionalInfo2(control: FormControl) {

        if (this.isLabel2Required && this.label2InputType != 'multiselect') {
            if (!control.value) {
                return { "isInvalidAdditionalInfo2": true };
            }
        } else if (this.isLabel2Required && this.label2InputType == 'multiselect') {
            if (control.value != null && control.value != undefined && control.value != '') {
                return null;
            } else {
                return { "isInvalidAdditionalInfo2": true };
            }
        }
        return null;
    }

    validateNameAdditionalInfo3(control: FormControl) {
        if (this.isLabel3Required && this.label3InputType != 'multiselect') {
            if (!control.value) {
                return { "isInvalidAdditionalInfo3": true };
            }
        } else if (this.isLabel3Required && this.label3InputType == 'multiselect') {
            if (control.value != null && control.value != undefined && control.value != '') {
                return null;
            } else {
                return { "isInvalidAdditionalInfo3": true };
            }
        }
        return null;
    }

    validateCustomValidations() {

        if (this.label2InputType == 'multiselect' && this.label2CustomValidationFunction == 'validateLabel2MultiSelectOptions') {
            if (this.lovForm.additionalInfo1 != this.lovForm.additionalInfo2.length) {
                this.hideValidationMsg();
                this.label2MultiSelectCount = this.lovForm.additionalInfo1;
                this.ValidationErrs.Label2WorkingDaysError = false;
                return true;
            }
        }

        if (this.lovForm.name != "" && this.lovForm.name != null && this.lovForm.name != undefined) {
            if (this.validateInputName(this.lovForm.name.trim())) {
                this.hideValidationMsg();
                this.ValidationErrs.DuplicateNameError = false;
                return true;
            }
        } else {
            this.hideValidationMsg();
            this.ValidationErrs.NameRequiredError = false;
            return true;
        }
    }

    hideValidationMsg() {
        this.ValidationErrs.Label2WorkingDaysError = true;
        this.ValidationErrs.DuplicateNameError = true;
        this.ValidationErrs.NameRequiredError = true;
    }

	showAddNewLOVDialog(id: any) {

        if (this.label1InputType == 'multiselect') { this.valAddInfo1 = []; }
        if (this.label2InputType == 'multiselect') { this.valAddInfo2 = []; }
        if (this.label3InputType == 'multiselect') { this.valAddInfo3 = []; }

        this.userform = this.fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength), this.validateName.bind(this)])],
            'additionalInfo1': [this.valAddInfo1, this.validateNameAdditionalInfo1.bind(this)],
            'additionalInfo2': [this.valAddInfo2, this.validateNameAdditionalInfo2.bind(this)],
            'additionalInfo3': [this.valAddInfo3, this.validateNameAdditionalInfo3.bind(this)]
        });

        this.hideValidationMsg();
        this.isNewLov = true;
        this.setAddNewLOVDialogHeader();
        this.lovForm = new PrimeLOV();
        this.addNewLOVDialog = true;
    }

	renamePropertyNames(json: any, _firstOption: any, _fieldForSave: any, _inputType: any) {

        let fieldForSave = "id";
        if (_fieldForSave) {
            if (_fieldForSave == "label") {
                fieldForSave = "name";
            }
        }

        var obj = JSON.parse(json);
        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            if (_inputType != 'multiselect') {
                objddl.push({ 'label': _firstOption, 'value': '' })
            }

            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i][fieldForSave] });
                }
            }
        }
        return objddl;
    }

	displayAdditionalInputTypes(lovTypeObj: any) {

        this.hideAdditionalFields();
        this.txtTypeID = this.selectedLOV;

        if (lovTypeObj) {

            if (lovTypeObj['label1'] != "" && lovTypeObj['label1InputType'] != "") {
                this.isLabel1 = true;
                this.label1 = lovTypeObj['label1'];
                this.label1InputType = lovTypeObj['label1InputType'];
                this.isLabel1Required = lovTypeObj['label1IsRequired'];
                this.label1CustomValidationFunction = lovTypeObj['label1CustomValidationFunction'];

                if ((lovTypeObj['label1ValueLOVTypeID'] > 0) && (this.label1InputType == 'dropdown' || this.label1InputType == 'multiselect')) {
                    this.label1DropDownFieldForSave = lovTypeObj['label1DropDownFieldForSave'];
                    this.seedDataService.getLOVByType(lovTypeObj['label1ValueLOVTypeID']).subscribe((lstLOV: LOV[]) => {
                        this.ddlLabel1 = this.renamePropertyNames(JSON.stringify(lstLOV), '--- Select ---', this.label1DropDownFieldForSave, this.label1InputType);
                    });
                }
            }
            if (lovTypeObj['label2'] != "" && lovTypeObj['label2InputType'] != "") {
                this.isLabel2 = true;
                this.label2 = lovTypeObj['label2'];
                this.label2InputType = lovTypeObj['label2InputType'];
                this.isLabel2Required = lovTypeObj['label2IsRequired'];
                this.label2CustomValidationFunction = lovTypeObj['label2CustomValidationFunction'];

                if ((lovTypeObj['label2ValueLOVTypeID'] > 0) && (this.label2InputType == 'dropdown' || this.label2InputType == 'multiselect')) {
                    this.label2DropDownFieldForSave = lovTypeObj['label2DropDownFieldForSave'];
                    this.seedDataService.getLOVByType(lovTypeObj['label2ValueLOVTypeID']).subscribe((lstLOV: LOV[]) => {
                        this.ddlLabel2 = this.renamePropertyNames(JSON.stringify(lstLOV), '--- Select ---', this.label2DropDownFieldForSave, this.label2InputType);
                    });
                }
            }
            if (lovTypeObj['label3'] != "" && lovTypeObj['label3InputType'] != "") {
                this.isLabel3 = true;
                this.label3 = lovTypeObj['label3'];
                this.label3InputType = lovTypeObj['label3InputType'];
                this.isLabel3Required = lovTypeObj['label3IsRequired'];
                this.label3CustomValidationFunction = lovTypeObj['label3CustomValidationFunction'];

                if ((lovTypeObj['label3ValueLOVTypeID'] > 0) && (this.label3InputType == 'dropdown' || this.label3InputType == 'multiselect')) {
                    this.label3DropDownFieldForSave = lovTypeObj['label3DropDownFieldForSave'];
                    this.seedDataService.getLOVByType(lovTypeObj['label3ValueLOVTypeID']).subscribe((lstLOV: LOV[]) => {
                        this.ddlLabel3 = this.renamePropertyNames(JSON.stringify(lstLOV), '--- Select ---', this.label3DropDownFieldForSave, this.label3InputType);
                    });
                }
            }
        }
    }

    hideAdditionalFields() {
        this.isLabel1 = false;
        this.label1 = "";
        this.label1InputType = "";
        this.isLabel1Required = false;
        this.label1DropDownFieldForSave = "";
        this.label1CustomValidationFunction = "";
        this.ddlLabel1 = [];

        this.isLabel2 = false;
        this.label2 = "";
        this.label2InputType = "";
        this.isLabel2Required = false;
        this.label2DropDownFieldForSave = "";
        this.label2CustomValidationFunction = "";
        this.ddlLabel2 = [];

        this.isLabel3 = false;
        this.label3 = "";
        this.label3InputType = "";
        this.isLabel3Required = false;
        this.label3DropDownFieldForSave = "";
        this.label3CustomValidationFunction = "";
        this.ddlLabel3 = [];
    }

    onSubmit(data: string) {

        var IsValid = this.validateCustomValidations();
        if (IsValid) {
            return false;
        }

        this.currentUserId = JSON.parse(window.localStorage.getItem('currentUser')).UserId;
        this.txtTypeVal = data['name'].trim();
        this.txtTypeID = this.selectedLOV;
        this.lovForm.lovTypeID = this.txtTypeID;
        this.msgs = [];

        if (this.txtTypeVal != "" && this.txtTypeVal != null) {
            if (!this.validateInputName(this.txtTypeVal)) {

                if (this.label1InputType == 'multiselect') {
                    let options = this.lovForm.additionalInfo1;
                    let strAdditionalInfo1 = ""

                    if (options != undefined && options != null && options != '') {
                        for (let i = 0; i < options.length; i++) {
                            if (i === options.length - 1) {
                                strAdditionalInfo1 += options[i].valueOf();
                            } else {
                                strAdditionalInfo1 += options[i].valueOf() + ',';
                            }
                        }
                    }
                    this.lovForm.additionalInfo1 = strAdditionalInfo1;
                }

                if (this.label2InputType == 'multiselect') {
                    let options = this.lovForm.additionalInfo2;
                    let strAdditionalInfo2 = ""

                    if (options != undefined && options != null && options != '') {
                        for (let i = 0; i < options.length; i++) {
                            if (i === options.length - 1) {
                                strAdditionalInfo2 += options[i].valueOf();
                            } else {
                                strAdditionalInfo2 += options[i].valueOf() + ',';
                            }
                        }
                    }
                    this.lovForm.additionalInfo2 = strAdditionalInfo2;
                }

                if (this.label3InputType == 'multiselect') {
                    let options = this.lovForm.additionalInfo3;
                    let strAdditionalInfo3 = ""

                    if (options != undefined && options != null && options != '') {
                        for (let i = 0; i < options.length; i++) {
                            if (i === options.length - 1) {
                                strAdditionalInfo3 += options[i].valueOf();
                            } else {
                                strAdditionalInfo3 += options[i].valueOf() + ',';
                            }
                        }
                    }
                    this.lovForm.additionalInfo3 = strAdditionalInfo3;
                }

                //this.blockedDocument = true;

                if (this.isNewLov) {
                    this.lovForm.createdBy = this.currentUserId;
                } else {
                    this.lovForm.modifiedBy = this.currentUserId;
                }

                this.seedDataService.SaveLOV(this.lovForm).subscribe((returnedSyncValue: boolean) => {
                    this.synced = returnedSyncValue;
console.log("this is synced")
                    if (this.synced) {
                        //this.blockedDocument = false;
                        if (this.isNewLov) {
                            this.msgs.push({ severity: 'success', summary: '', detail: 'Records Added Successfully!' });

                        } else {
                            this.msgs.push({ severity: 'success', summary: '', detail: 'Record Updated Successfully!' });
                        }
                        this.selectedLOV = this.txtTypeID;
                        this.bindList(this.txtTypeID,null);
                    }
                });

                this.cancel();
                this.addNewLOVDialog = false;
            }
        }
    }

	validateInputName(name: any) {
        this.isNameTake = false;
        var obj = this.listLOV;

        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("name")) {
                if (obj[i]["name"] != '' && obj[i]["name"] != null) {
                    if (!this.isNewLov) {
                        if (obj[i]["name"].toUpperCase() == name.toUpperCase() && obj[i]["id"] != this.hdnLOVID) {
                            this.isNameTake = true;
                            break;
                        }
                    }
                    else {
                        if (obj[i]["name"].toUpperCase() == name.toUpperCase()) {
                            this.isNameTake = true;
                            break;
                        }
                    }
                }
            }
        }
        return this.isNameTake;
    }

	validateName(control: FormControl) {
        if (control.value) {
            if (this.validateInputName(control.value)) {
                return { "nameAlreadyExist": true };
            }
            return null;
        }
    }

    cancel() {

        if (this.label1InputType == 'multiselect') { this.valAddInfo1 = []; }
        if (this.label2InputType == 'multiselect') { this.valAddInfo2 = []; }
        if (this.label3InputType == 'multiselect') { this.valAddInfo3 = []; }

        this.userform = this.fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength), this.validateName.bind(this)])],
            'additionalInfo1': [this.valAddInfo1, this.validateNameAdditionalInfo1.bind(this)],
            'additionalInfo2': [this.valAddInfo2, this.validateNameAdditionalInfo2.bind(this)],
            'additionalInfo3': [this.valAddInfo3, this.validateNameAdditionalInfo3.bind(this)]
        });

        this.lovForm = new PrimeLOV();
        this.addNewLOVDialog = false;
    }

    disableLOVActions() {
        this.LOVActions.AddNew = false;
        this.LOVActions.Edit = false;
        this.LOVActions.Delete = false;
    }

    enableLOVActions() {
        this.LOVActions.AddNew = true;
        this.LOVActions.Edit = true;
        this.LOVActions.Delete = true;
    }

	bindList(typeID: any, dtListLov: DataTable) {

        if (dtListLov != null && dtListLov != undefined) {
            dtListLov.reset();
            this.txtKeywordSearch = "";
        }

        //this.blockedDocument = true;

        this.seedDataService.getLOVTypeByID(typeID).subscribe((lovTypeObj: LOVTypeVal) => {
            this.displayAdditionalInputTypes(lovTypeObj);
            this.PageHeading = lovTypeObj['displayName']; //lovTypeObj['lovType']; changed by Raveendra Sharma

            this.seedDataService.getLOVAccessTypes().subscribe((lovAccessTypeObj: LOVAccessType[]) => {
                this.disableLOVActions();
                if (lovTypeObj['lovAccessType'] != null && lovTypeObj['lovAccessType'] != undefined && lovTypeObj['lovAccessType'] != '') {
                    this.disableLOVActions();
                    var obj = JSON.parse(JSON.stringify(lovAccessTypeObj));
                    if (obj != null && obj != undefined && obj != '') {
                        for (var i = 0; i < obj.length; i++) {
                            if (obj[i]['value'] == lovTypeObj['lovAccessType']) {
                                switch (lovTypeObj['lovAccessType']) {
                                    case ('ReadOnly'):
                                        this.disableLOVActions();
                                        break;
                                    case ('ReadWrite'):
                                        this.disableLOVActions();
                                        this.LOVActions.AddNew = true;
                                        this.LOVActions.Edit = true;
                                        break;
                                    case ('ReadAdd'):
                                        this.disableLOVActions();
                                        this.LOVActions.AddNew = true;
                                        break;
                                    case ('ReadWriteDelete'):
                                        this.disableLOVActions();
                                        this.enableLOVActions();
                                        break;
                                }
                                break;
                            }
                        }
                    }
                }
            });

            if (this.label1InputType == 'multiselect') { this.valAddInfo1 = []; }
            if (this.label2InputType == 'multiselect') { this.valAddInfo2 = []; }
            if (this.label3InputType == 'multiselect') { this.valAddInfo3 = []; }

            this.userform = this.fb.group({
                'name': ['', Validators.compose([Validators.required, Validators.maxLength(this.nameMaxLength), this.validateName.bind(this)])],
                'additionalInfo1': [this.valAddInfo1, this.validateNameAdditionalInfo1.bind(this)],
                'additionalInfo2': [this.valAddInfo2, this.validateNameAdditionalInfo2.bind(this)],
                'additionalInfo3': [this.valAddInfo3, this.validateNameAdditionalInfo3.bind(this)]
            });
        });

        this.seedDataService.getLOVByType(typeID).subscribe((lstLOV: LOV[]) => {
            this.listLOV = [];
            this.listLOV = lstLOV;
            //this.blockedDocument = false;
        });
    }

    editLOV(event: any, ediLovOBJ: LOV) {
        this.isNewLov = false;
        this.hideValidationMsg();
        this.txtTypeID = this.selectedLOV;
        this.hdnLOVID = ediLovOBJ['id'];
        this.setAddNewLOVDialogHeader();
        this.lovForm = this.setLOV(ediLovOBJ);
        this.addNewLOVDialog = true;
    }

    setLOV(editLovObj: LOV): PrimeLOV {
        let lov = new PrimeLOV();

        for (let prop in editLovObj) {
            if (prop == 'additionalInfo1' || prop == 'additionalInfo2' || prop == 'additionalInfo3') {
                if (editLovObj[prop] == 'true') {
                    lov[prop] = editLovObj[prop];
                }
                else if (editLovObj[prop] == 'false') {

                }
                else {
                    if (prop == 'additionalInfo1' && this.label1InputType == 'multiselect') {
                        lov[prop] = editLovObj[prop].split(',').filter(Boolean);
                    }
                    else if (prop == 'additionalInfo2' && this.label2InputType == 'multiselect') {
                        lov[prop] = editLovObj[prop].split(',').filter(Boolean);
                    }
                    else if (prop == 'additionalInfo3' && this.label3InputType == 'multiselect') {
                        lov[prop] = editLovObj[prop].split(',').filter(Boolean);
                    }
                    else {
                        lov[prop] = editLovObj[prop];
                    }
                }
            }
            else {
                lov[prop] = editLovObj[prop];
            }
        }
        return lov;
    }

    setAddNewLOVDialogHeader() {
        this.txtTypeID = this.selectedLOV;
        var obj = this.menuLOVTypes;
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("value")) {
                if (obj[i]["value"] == this.txtTypeID) {
                    if (this.isNewLov) {
                        this.headerLabel = "Add New: " + obj[i]["label"];
                    }
                    else {
                        this.headerLabel = "Edit: " + obj[i]["label"];
                    }
                    this.lblType = obj[i]["label"];
                }
            }
        }
    }

	deleteLOV(id: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                this.seedDataService.DeleteLOV(id)
                this.seedDataService.DeleteLOV(id).subscribe((returnedSyncValue: boolean) => {
                    this.synced = returnedSyncValue;
                    if (this.synced) {
                        this.msgs = [];
                        this.msgs.push({ severity: 'success', summary: '', detail: 'Record Deleted Successfully!' });
                        this.bindList(this.selectedLOV,null);
                    }
                });
            }
        });
    }

	preventSpecialCharacters(event: any) {
        let regex = new RegExp('[^a-zA-Z0-9-,. ]');
        if (regex.test(event.key)) {
            event.preventDefault();
        }
    }
}

class PrimeLOV implements LOV {
    constructor(
		public id?: any,
		public lovTypeID?: any,
		public name?: any,
		public isDelete?: any,
		public additionalInfo1?: any,
		public additionalInfo2?: any,
		public additionalInfo3?: any,
		public createdBy?: any,
		public modifiedBy?: any
    ) { }
}

interface IValidation {
    [key: string]: boolean;
}


// WEBPACK FOOTER //
// ./src/app/Components/SeedData/seed.data.ts